import { Address, GenericObject, copyFields, fixDates } from '@synergy/models';

import { Contact } from '../../../common/models/contact';
import { SalesOrderPositionItem } from './salesOrder-position-item';

export class SalesOrderPosition {
    public id?: number;
    public desiredDeliveryDate!: Date;
    public costCentre!: string;
    public functionalAsset!: string;
    public deliveryAddress!: Address;
    public isDesiredDeliveryDateFrom!: boolean;
    public customerContact!: Contact;
    public avisoContact!: Contact;
    public items!: SalesOrderPositionItem[];

    public static fromPlainObject(object: GenericObject): SalesOrderPosition {
        const position = new SalesOrderPosition();

        // Import own keys
        copyFields(object, position);

        // Import special keys
        if (object['deliveryAddress']) {
            position.deliveryAddress = Address.fromPlainObject(object['deliveryAddress']);
        }

        if (object['customerContact']) {
            position.customerContact = Contact.fromPlainObject(object['customerContact']);
        }

        if (object['avisoContact']) {
            position.avisoContact = Contact.fromPlainObject(object['avisoContact']);
        }

        if (object['items']) {
            position.items = object['items'].map(SalesOrderPositionItem.fromPlainObject);
        }

        fixDates(position, ['desiredDeliveryDate']);

        return position;
    }
}
